import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const PricePlansState = (state: RootState) => state.supportAtHome.pricePlans;

export const selectPricePlans = (state: RootState) => PricePlansState(state).rows;
export const selectPricePlansLoading = (state: RootState) => PricePlansState(state).loading;
export const selectPricePlan = (state: RootState) => PricePlansState(state).row;
export const selectErrorResponse = (state: RootState) => PricePlansState(state).error;
export const selectPricePlansTotal = (state: RootState) => PricePlansState(state).total;

export const selectPricePlanById = createSelector([selectPricePlans, (_: RootState, id?: string) => id], (rows, id) =>
  rows.find(({ id: rowId }) => id === rowId),
);
